import { Puzzle, Cpu, Target, Layers, ShieldCheck, Headset } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REASONS = [
  { icon: Puzzle, title: "Custom Solutions", text: "We don't force your business into a generic software model." },
  { icon: Cpu, title: "Modern Technology", text: "Use modern and scalable technologies to build reliable digital products." },
  { icon: Target, title: "Business-Focused", text: "We focus on solving business problems, not just writing code." },
  { icon: Layers, title: "Scalable Architecture", text: "Build today with the ability to grow tomorrow." },
  { icon: ShieldCheck, title: "Security & Reliability", text: "Security, data protection and reliable infrastructure are considered from the beginning." },
  { icon: Headset, title: "Post-Launch Support", text: "Technical support, maintenance and continuous improvements after launch." },
];

export const WhyRCS = () => (
  <section id="why-rcs" className="bg-mist py-24 sm:py-32" data-testid="why-rcs-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Why RCS</Eyebrow>
        <h2 className="mt-5 max-w-xl font-jakarta text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid="why-rcs-heading">
          Why Businesses Choose RCS
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={(i % 3) * 0.09}>
            <div
              className="group relative h-full overflow-hidden rounded-xl border border-slate-200 bg-white p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-magenta/40 hover:shadow-[0_24px_50px_-24px_rgba(254,52,188,0.22)]"
              data-testid={`why-rcs-card-${i + 1}`}
            >
              <span className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-gold to-magenta transition-transform duration-500 group-hover:scale-x-100" />
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-gold-light">
                  <r.icon className="h-5 w-5" />
                </span>
                <span className="font-mono2 text-[11px] font-semibold tracking-widest text-slate-300">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="mt-5 font-jakarta text-lg font-bold text-navy">{r.title}</h3>
              <p className="mt-2 font-inter text-[13.5px] leading-relaxed text-slate-500">{r.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
